export default "__VITE_ASSET__D6OxB8E0__"